import { z } from 'zod'

import { IChangePassword } from '..'

const validatePassword = (data: string) => {
  const errors: string[] = ['Password must:']
  let isValid = true
  let message = ''
  let path: (number | string)[] = ['password']

  if (data.length < 8) {
    errors.push('be at least 8 characters')
    isValid = false
    message = 'be at least 8 characters'
  }
  if (!/[a-z]/.test(data)) {
    errors.push('contain at least one lowercase letter')
    isValid = false
    message = 'contain at least one lowercase letter'
  }
  if (!/[A-Z]/.test(data)) {
    errors.push('contain at least one uppercase letter')
    isValid = false
    message = 'contain at least one uppercase letter'
  }
  if (!/\d/.test(data)) {
    errors.push('contain at least one number')
    isValid = false
    message = 'contain at least one number'
  }
  if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-|=]/.test(data)) {
    errors.push('contain at least one special character')
    isValid = false
    message = 'contain at least one special character'
  }

  if (!isValid && errors.length > 0) {
    message = errors.join(' \n')
  }

  return { isValid, message, path }
}

export const changePasswordSchema: z.ZodType<IChangePassword> = z
  .object({
    confirmPassword: z.string().min(1, 'Password confirmation is required'),
    password: z.string().refine(data => {
      const { isValid, message } = validatePassword(data)

      return isValid ? true : message
    }),
  })
  .refine(({ confirmPassword, password }) => password === confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  })

export const userDataSchema = z.object({
  email: z.email('This is not valid email').optional(),
  id: z.number(),
  last_name: z.string().optional().nullable(),
  name: z.string().min(1, 'First name is required'),
  phone: z.string().nullable().optional(),
})
